import { Tabs, TabsProps } from "antd";
import React, { FC } from "react";
import { CreditAssessment } from "./CreditAssessment/CreditAssessment";
import { StopFactors } from "./StopFactors/StopFactors";
import { BusinessRisks } from "./BusinessRisks/BusinessRisks";

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Стоп-факторы",
    children: <StopFactors />,
  },
  {
    key: "2",
    label: "Бизнес-риски",
    children: <BusinessRisks />,
  },
  {
    key: "3",
    label: "Оценка кредитоспособности",
    children: <CreditAssessment />,
  },
];

export const Scoring: FC = () => {
  return <Tabs defaultActiveKey="1" items={items} />;
};
